import AirlinesService from './airlines.servicse';
import configData from "../components/configFile.json";
import { Auth } from 'aws-amplify';
//import { CognitoUser } from 'amazon-cognito-identity-js';

//Convert Payload from Base64-URL to JSON
// const decodePayload = payload => {
//   const cleanedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
//   const decodedPayload = atob(cleanedPayload)
//   const uriEncodedPayload = Array.from(decodedPayload).reduce((acc, char) => {
//     const uriEncodedChar = ('00' + char.charCodeAt(0).toString(16)).slice(-2)
//     return `${acc}%${uriEncodedChar}`
//   }, '')
//   const jsonPayload = decodeURIComponent(uriEncodedPayload);

//   return JSON.parse(jsonPayload)
// }

//Generate a Random String
const getRandomString = () => {
  const randomItems = new Uint32Array(28);
  crypto.getRandomValues(randomItems);

  const binaryStringItems = randomItems.map(dec => `0${dec.toString(16).substr(-2)}`)
  return binaryStringItems.reduce((acc, item) => `${acc}${item}`, '');
}

//Encrypt a String with SHA256
const encryptStringWithSHA256 = async str => {
  const PROTOCOL = 'SHA-256'
  const textEncoder = new TextEncoder();
  const encodedData = textEncoder.encode(str);
  return crypto.subtle.digest(PROTOCOL, encodedData);
}

//Convert Hash to Base64-URL
const hashToBase64url = arrayBuffer => {
  const items = new Uint8Array(arrayBuffer)
  const stringifiedArrayHash = items.reduce((acc, i) => `${acc}${String.fromCharCode(i)}`, '')
  const decodedHash = btoa(stringifiedArrayHash)

  const base64URL = decodedHash.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  return base64URL
}

class UserProfileService {

  OnLoadSignInCognito = async () => {
    //var tokens;
    var domain = configData.domain;
    var region = configData.region;
    var appClientId = configData.appClientId;
    //var userPoolId = configData.userPoolId;
    var redirectURI = configData.redirectURI;

    // Create random "state"
    var state = getRandomString();
    sessionStorage.setItem("pkce_state", state);

    // Create PKCE code verifier
    var code_verifier = getRandomString();

    sessionStorage.setItem("code_verifier", code_verifier);

    // Create code challenge
    var arrayHash = await encryptStringWithSHA256(code_verifier);
    var code_challenge = hashToBase64url(arrayHash);
    sessionStorage.setItem("code_challenge", code_challenge)

    // Redirtect user-agent to /authorize endpoint
    return "https://" + domain + ".auth." + region + ".amazoncognito.com/oauth2/authorize?response_type=code&state=" + state + "&client_id=" + appClientId + "&redirect_uri=" + redirectURI + "&scope=openid&code_challenge_method=S256&code_challenge=" + code_challenge;
  }

  signIn = async (userName) => {
    var signInResult = await Auth.signIn(userName);
    return signInResult;
  }
  answerCustomChallenge = async (cognitoUser, confirmationCode) => {
    // debugger;
    var result = await Auth.sendCustomChallengeAnswer(cognitoUser, confirmationCode);
    // console.log("result: " + result);
    return result;
  }
  signOut = async () => {
    var signOutResult = await Auth.signOut();

    return signOutResult;
  }
 // data.getAccessToken().getJwtToken()
  GetCurrentSession = async () => {
    var ReturnObj = {};
    //let session =
      await Auth.currentSession()
      .then(data => ReturnObj.sessionData = data
      )
      .catch((error) => {
          
        //error = {code: 'NotAuthorizedException', name: 'NotAuthorizedException', message: 'Refresh Token has expired'}
        if (error.message === 'Refresh Token has expired') {
          //console.log(configData.expiredSession);          
          // window.location.replace(configData.expiredSession);
        }
        else if (error === "No current user") {
          ReturnObj.error = error;
        }

        //return ReturnObj;

      });

    return ReturnObj;
  }

  GetUserInfo = async (CurrentSession) => {
    var ReturnObj = {};

    //  let CurrentSession = sessionStorage.getItem('SessionId');
//let session =
     await Auth.currentSession()
      .then(data => ReturnObj.sessionData = data
      )
      .catch((error) => {
        if (error === "No current user") {
          ReturnObj.error = error;
        }
        // else if (error.message === "Refresh Token has expired") {
        //   ReturnObj.error=error.message;
        // }
        // else if (error.code === 'NotAuthorizedException') {
        //   // The error happens when the incorrect password is provided
        // }
        // else {
        //window.location.replace(configData.signOutUrl);
        //}
      });

    await Auth.currentAuthenticatedUser().then(res => {
      ReturnObj = {
        session: CurrentSession,
        email: res.attributes.email,
        airlineCode: res.attributes["custom:airline_code"],
        faxNumber: res.attributes["custom:fax"],
        role: res.attributes["custom:role"],
        lastName: res.attributes.family_name,
        firstName: res.attributes.given_name,
        phoneNumber: res.attributes.phone_number,
        IsLogged:false,//default
        airline:{}//default
      };
    })
      .catch(
        (error) => {
          ReturnObj.error = error;
        });
    //if (ReturnObj.error !== undefined) {
    ReturnObj.IsLogged = true;
    let airlineRes = await AirlinesService.getUserAirline(ReturnObj.airlineCode);
    ReturnObj.airline = airlineRes;
    //}
    return ReturnObj;
  }
}

export default new UserProfileService();